var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MemberProfileEditLocation.jinja');
require('./MemberProfileEditLocation.less');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MemberProfileEditLocation-buttons-button--cancel': 'cancelEdit',
        'click .MemberProfileEditLocation-buttons-button--save': 'saveEdit'
    },


    saveApi: function () {
        return Urls['member:api:member'](this.options.memberId, 'json');
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onResize', 'saveApi');

        if (!app.settings.isPhone) {
            this.locationJsp = this.$('.MemberProfileEditLocation-bodyForm-scrollBlock')
                .jScrollPane()
                .bind('mousewheel', function (e) {
                    e.preventDefault();
                })
                .data('jsp');
        }

        $(window).on('resize', this.onResize);
        this.onResize();

        Base.prototype.initialize.call(this, options);
    },


    onResize: function () {
        if (!app.settings.isPhone) {
            this.locationJsp.reinitialise();
        }
    },


    deactivate: function (params) {
        $(window).off('resize', this.onResize);

        return Base.prototype.deactivate.call(this, params);
    },


    saveEdit: function () {
        var data = [];

        this.$('.MemberProfileEditLocation-bodyForm-input:checked').each(function () {
            data.push($(this).val() - 0);
        });

        var $button = this.$('.MemberProfileEditLocation-buttons-button--save');

        $button.addClass('Button--loading');

        this.saveXhr = $.ajax({
            url: this.saveApi(),
            method: 'PATCH',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                'locations': data
            }),
            success: function (responseData) {

                app.vent.trigger('need-reload', 'my-adg');// refresh my-adg page if it's current underlying page, to update member info block on it

                $button.removeClass('Button--loading');

                //save response to cache, it's important for all popup edit panels, which renders on the fly to show actual data
                //response always contain all profile data up-to-date
                window.app.data.members[this.options.memberId] = responseData;

                window.app.vent.trigger('MemberProfile--updateLocation', this.options.memberId);

                this.cancelEdit();
            },
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    alert('Can\'t update locations!');
                }

                console.log('error', arguments);
            },
            context: this
        });
    },


    cancelEdit: function () {
        this.saveXhr && this.saveXhr.abort();

        window.app.vent.trigger('MemberProfileEdit--close', 'location');
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MemberProfileEdit/MemberProfileEditLocation.js
// module id = 215
// module chunks = 0